<script lang="ts">
  import { getHref } from '../../helpers/sections-helper';
  import { BulletPoint } from '../../components/index';
  import './css/problemsWeSolve.scss';
  import type { ProblemsWeSolve } from '../types';

  export let properties: ProblemsWeSolve;

  $: ({ button, callouts, headline, icon, items, kicker } = properties);
</script>

<section class="problems-we-solve">
  <div class="wrapper">
    <div class="handle-top">
      <p class="sub-title">
        {@html kicker?.value}
      </p>
      <h2 class="h2">
        {@html headline?.value}
      </h2>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="231"
        height="24"
        viewBox="0 0 231 24"
        fill="none"
      >
        <path
          d="M222.745 2.85393C218.604 3.02094 214.429 3.26654 210.416 4.44053C189.957 -3.84611 166.969 1.62592 145.827 3.65951C98.6712 9.20031 47.4727 22.9098 2.60594 0.623849C2.55993 0.600068 2.50915 0.586997 2.45737 0.585594C2.4056 0.58419 2.35418 0.594501 2.30695 0.615754C2.25972 0.637007 2.21791 0.668641 2.18462 0.70832C2.15134 0.747999 2.12745 0.794692 2.11473 0.844898C2.08425 0.954193 2.09255 1.07067 2.13822 1.17454C2.18389 1.27841 2.26411 1.36327 2.36525 1.4147C46.9668 24.9975 98.7252 11.6956 146.23 6.98988C166.084 5.42294 186.745 1.42944 206.344 6.26781C200.528 9.46556 201.741 16.2982 208.883 15.6891C214.527 15.9298 217.317 9.32802 212.464 5.83063C218.341 4.32776 224.417 3.75266 230.472 4.12615C230.525 4.13015 230.579 4.12334 230.63 4.10612C230.681 4.0889 230.728 4.06161 230.769 4.02589C230.809 3.99017 230.842 3.94673 230.865 3.89814C230.888 3.84955 230.901 3.7968 230.904 3.74301C230.906 3.6267 230.866 3.51348 230.793 3.42353C230.719 3.33358 230.616 3.27273 230.501 3.2518C227.931 2.90325 225.337 2.77017 222.745 2.85393ZM211.496 11.8381C205.965 15.1095 201.751 11.1651 208.849 7.33372C210.489 8.16877 213.054 10.0255 211.496 11.8184V11.8381Z"
          fill="var(--color-accent)"
        />
        <path
          d="M18.6928 16.7893C35.1531 21.0235 52.252 23.342 69.2085 22.1926C69.244 22.1933 69.278 22.2069 69.3043 22.2308C69.3306 22.2547 69.3474 22.2873 69.3516 22.3225C69.3558 22.3578 69.3471 22.3934 69.3271 22.4228C69.3071 22.4522 69.2772 22.4733 69.2428 22.4824C52.1984 25.6792 34.5905 23.8004 18.6044 17.0791C18.5659 17.0674 18.5337 17.0409 18.5148 17.0054C18.496 16.9699 18.4919 16.9284 18.5037 16.89C18.5154 16.8516 18.5419 16.8194 18.5774 16.8005C18.6128 16.7816 18.6543 16.7776 18.6928 16.7893Z"
          fill="var(--color-accent)"
        />
        <path
          d="M73.4527 20.7437C75.0568 20.3381 76.7121 20.1725 78.3648 20.2524C78.5056 20.2649 78.6373 20.3275 78.7358 20.4289C78.8343 20.5303 78.8931 20.6637 78.9014 20.8049C78.9098 20.946 78.8671 21.0854 78.7812 21.1977C78.6953 21.31 78.5719 21.3877 78.4335 21.4166C76.8284 21.7221 75.1995 21.8864 73.5657 21.9078C73.4222 21.9037 73.2851 21.8474 73.1802 21.7494C73.0753 21.6514 73.0098 21.5184 72.9959 21.3756C72.9821 21.2327 73.0208 21.0896 73.1049 20.9733C73.189 20.857 73.3127 20.7753 73.4527 20.7437Z"
          fill="var(--color-accent)"
        />
      </svg>
    </div>
    <div class="we-handle-boxes">
      {#each items as item}
        <div class="handle-box">
          <BulletPoint bulletIcon={icon} />
          <p class="text-small">{item}</p>
        </div>
      {/each}
    </div>
    {#if button?.label?.length}
      <div class="bottom-boxes">
        <a
          id="problems-we-solve-book-now"
          class="primary-button open-form-js"
          href={getHref(button.link_type, button.link)}
          >{@html button.label}
        </a>
        <div class="small-text-box">
          {#each callouts.value as item}
            <div>
              <BulletPoint bulletIcon={callouts?.icon} />
              <p class="text-small">{@html item}</p>
            </div>
          {/each}
        </div>
      </div>
    {/if}
  </div>
</section>
